<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-btn icon v-on="on" @click="open = true">
          <v-icon>sort</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('sorting') }}</span>
    </v-tooltip>
    <v-dialog v-model="open" :max-width="768" persistent scrollable>
      <SortingFilterForm
        :key="formKey"
        :value="value"
        @close="open = false"
        @submit="handleSubmit"
      />
    </v-dialog>
  </div>
</template>

<script>
import SortingFilterForm from './SortingFilterForm.vue'

export default {
  components: { SortingFilterForm },
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      open: false,
      formKey: Date.now()
    }
  },
  watch: {
    open(value) {
      if (value) {
        this.formKey = Date.now()
      }
    }
  },
  methods: {
    handleSubmit(value) {
      this.$emit('input', value)
      this.open = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/SortingFilter.vue